export default [
    {
        path: '/general-application-form',
        name: 'general-application-form',
        component: () => import('@/views/page/wasa/GeneralApplicationForm.vue'),
        meta: {
            layout: 'wasa'
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pending-general-application/:pageId',
        name: 'pending-general-application',
        component: () => import('@/views/page/wasa/PendingGeneralApplication.vue'),
        meta: {
            requiresAuth: true
        }
    }
]
